/* Conversations */
import composerAct from './conversations/composerAct'

import rolesAct from './rolesAct'

import modulesAct from '../modules/actions'

// Conversation Plugins
import { newPaymentLinkAct, cancelPaymentLinkAct, customPaymentAct, renewPaymentLink } from './conversations/plugins/payment'
import searchAct from './conversations/plugins/search'
import locatorsAct from './conversations/plugins/locatorsAct'
import virtualAssistant from './conversations/plugins/virtualAssistant'
import trackingUserInfoAct from './conversations/plugins/trackingUserInfoAct'
import trackingUserHistoryAct from './conversations/plugins/trackingUserHistoryAct'

import { addUserTab } from './tabs'
import { updateUser, selectUser } from './conversations/user'
import { getAssignations } from './assignations'

import notificationsAct from './notificationsAct'

import categoriesAct from './conversations/categoriesAct'

// Marketing
import marketingAct from './marketing'

// Pools
import poolsActions from '../pools/actions'

// WALL
import wallAct, { addNode, addWall, updateNode } from './wall'
const nodeAct = { addNode, addWall, updateNode }

const activeUserAct = {
  updateUser,
  selectUser,
}

const assignationsAct = {
  getAssignations,
}

const tabsUsersAct = {
  addUserTab,
}

export {
  cancelPaymentLinkAct,
  newPaymentLinkAct,
  customPaymentAct,
  renewPaymentLink,
  composerAct,
  searchAct,
  locatorsAct,
  activeUserAct,
  assignationsAct,
  tabsUsersAct,
  notificationsAct,
  rolesAct,
  nodeAct,
  wallAct,
  marketingAct,
  modulesAct,
  categoriesAct,
  virtualAssistant,
  poolsActions,
  trackingUserInfoAct,
  trackingUserHistoryAct,
}
